import {
  ANALYTICS_EVENT,
  ANALYTICS_PAGEVIEW,
  LISTING_TYPES,
} from '../constants';

export const PAGE_LISTINGS_ACTIVE = 'FAN_SELLER: Listings Page: Active';
export const PAGE_LISTINGS_SOLD = 'FAN_SELLER: Listings Page: Sold';
export const PAGE_LISTINGS_EXPIRED = 'FAN_SELLER: Listings Page: Expired';
export const PAGE_FAN_SELL_LISTED = 'FAN_SELLER:LISTED';

export const ANALYTICS_LISTINGS_CATEGORY = 'Ticket Management';
export const ANALYTICS_LISTINGS_ACTION = 'Listings Management';

export const createAnalyticsCategory = (category, action) =>
  (label, value) => ({ category, action, label, value });

export const getPageEventByListingType = (listType) => {
  switch (listType) {
    case LISTING_TYPES.active:
      return PAGE_LISTINGS_ACTIVE;

    case LISTING_TYPES.sales:
      return PAGE_LISTINGS_SOLD;

    case LISTING_TYPES.expired:
      return PAGE_LISTINGS_EXPIRED;

    default:
      return null;
  }
};

/**
 *
 * @param {Object} options - for event tracking
 * @param {string} options.category - event category
 * @param {string} options.action - event action
 * @param {string} options.label - event label
 * @param {string} options.value - event value
 */
export function trackEvent({ category, action, label, value }) {
  return {
    type: ANALYTICS_EVENT,
    payload: {
      category,
      action,
      label,
      value,
    },
  };
}

export function trackPageview(pagename) {
  return {
    type: ANALYTICS_PAGEVIEW,
    payload: pagename,
  };
}

export const trackPageviewByListingType = listType =>
  trackPageview(getPageEventByListingType(listType));

const createTicketManagementEvent = createAnalyticsCategory(
  ANALYTICS_LISTINGS_CATEGORY,
  ANALYTICS_LISTINGS_ACTION,
);

export const trackOpenEditListingModal = ({ source = 'user-click' } = {}) =>
  trackEvent(createTicketManagementEvent(
    source === 'deep-link' ? 'Open Change Pricing - deep-link' : 'Open Change Pricing',
    1,
  ));

export const trackEditListingConfirm = () =>
  trackEvent(createTicketManagementEvent('Change Pricing Confirm', 0));

export const trackEditListingCancel = () =>
  trackEvent(createTicketManagementEvent('Change Pricing Cancel', 0));

export const trackRemoveListingConfirm = () =>
  trackEvent(createTicketManagementEvent('Remove Listing', 0));

export const trackLoadNextListingPage = () =>
  trackEvent(createTicketManagementEvent('Load More Listings', 1));
